<template>
  <div>
    <Breadcrumbs title="Vehicle look up" main="Catalog"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <form @submit.prevent="prepareSearchCars">
                    <div class="input-group">
                      <input class="form-control" placeholder="VIN" v-model="vin">
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="submit">Search</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-8">
                  <form class="form-inline pull-right">
                    <select type="text" class="form-control mb-2 mr-sm-2" placeholder="Make">
                      <option value="">Make</option>
                      <option value="BMW" selected>BMW</option>
                    </select>
                    <select type="text" class="form-control mb-2 mr-sm-2" placeholder="Model"
                            @change="selectModel()" v-model="selectedProperty" style="width: 200px">
                      <option value="null">Model</option>
                      <option :value="property" v-for="(property, index) in carProperties" :key="index">
                        {{ property.model }}
                      </option>
                    </select>
                    <select type="text" class="form-control mb-2 mr-sm-2" placeholder="Year"
                            @change="selectYear()" v-model="selectedYear">
                      <option value="null">Year</option>
                      <option :value="year" v-for="(year, index) in years" :key="index">{{ year.year }}</option>
                    </select>
                    <select type="text" class="form-control mb-2 mr-sm-2" placeholder="Engine"
                            @change="selectEngine()" v-model="selectedEngine">
                      <option value="null">Engine</option>
                      <option :value="engine" v-for="(engine, index) in engines" :key="index">{{ engine }}</option>
                    </select>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="loaded || loadingProcess">
          <div class="card" v-if="currentStep === 'selectCar'">
            <div class="card-header">
              <h5 class="card-title mb-0">Cars</h5>
              <span>Select one car from in list below</span>
            </div>
            <div class="col-md-12" v-if="loadingProcess">
              <div class="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div class="table-responsive mb-0" style="max-height: 600px;" v-if="!loadingProcess">
              <table role="table" aria-busy="false" aria-colcount="4"
                     class="table b-table table-de table-striped table-hover" id="__BVID__497"><!----><!---->
                <thead role="rowgroup" class=""><!---->
                <tr role="row" class="">
                  <th role="columnheader" scope="col">
                    <div>Image</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>VIN</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Mark</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Model</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Prod date</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>View</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Serial number</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Body</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Engine</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Type</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Catalyst</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>St. wheel</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Transmission</div>
                  </th>
                </tr>
                </thead>
                <tbody role="rowgroup">
                <tr role="row" class="" style="cursor: pointer" v-for="(car, index) in cars" :key="index"
                    @click.prevent="selectCar(car)">
                  <td><img :src="car.car_img" alt=""></td>
                  <td>{{ car.car_vin }}</td>
                  <td>{{ car.car_mark }}</td>
                  <td>{{ car.car_model }}</td>
                  <td>{{ car.car_prod_date }}</td>
                  <td>{{ car.car_view }}</td>
                  <td>{{ car.car_serial_number }}</td>
                  <td>{{ car.car_body }}</td>
                  <td>{{ car.car_engine }}</td>
                  <td>{{ car.car_type }}</td>
                  <td>{{ car.car_catalyst }}</td>
                  <td>{{ car.car_steering_wheel }}</td>
                  <td>{{ car.car_transmission }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="currentStep === 'selectMainGroup'" class="col-md-12">
          <div class="btn btn-info mb-3" @click="backToCars">Back to cars</div>

          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title mb-0">Main group</h5>
                  <span>Select main group in list below</span>
                </div>
                <div class="col-md-12" v-if="loadingProcess">
                  <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div class="table-responsive mb-0" v-if="!loadingProcess">
                  <table role="table" aria-busy="false" aria-colcount="4"
                         class="table b-table table-de table-striped table-hover" id="__BVID__497"><!----><!---->
                    <thead role="rowgroup" class=""><!---->
                    <tr role="row" class="">
                      <th role="columnheader" scope="col">
                        <div>Image</div>
                      </th>
                      <th role="columnheader" scope="col">
                        <div>Main group</div>
                      </th>
                      <th role="columnheader" scope="col">
                        <div>Description</div>
                      </th>
                    </tr>
                    </thead>
                    <tbody role="rowgroup">
                    <tr role="row" class="" style="cursor: pointer" v-for="(group, index) in mainGroups" :key="index"
                        @click.prevent="selectMainGroup(group)">
                      <td><img :src="group.img" alt="" style="max-width: 150px;"></td>
                      <td>{{ group.hg }}</td>
                      <td>{{ group.description }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title mb-0">Functional groups</h5>
                  <span>Select functional group in list below</span>
                </div>
                <div class="col-md-12" v-if="loadingProcess">
                  <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div class="table-responsive mb-0" v-if="!loadingProcess">
                  <table role="table" aria-busy="false" aria-colcount="4"
                         class="table b-table table-de table-striped table-hover" id="__BVID__497"><!----><!---->
                    <thead role="rowgroup" class=""><!---->
                    <tr role="row" class="">
                      <th role="columnheader" scope="col">
                        <div>Main group</div>
                      </th>
                      <th role="columnheader" scope="col">
                        <div>Functional group</div>
                      </th>
                      <th role="columnheader" scope="col">
                        <div>Description</div>
                      </th>
                    </tr>
                    </thead>
                    <tbody role="rowgroup">
                    <tr role="row" class="" style="cursor: pointer" v-for="(group, index) in functionalGroups"
                        :key="index"
                        @click.prevent="selectFunctionalGroup(group)">
                      <td>{{ group.hg }}</td>
                      <td>{{ group.fg }}</td>
                      <td>{{ group.description }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentStep === 'selectScheme'">
          <div class="col-md-12">
            <div class="btn btn-info mb-3" @click="backToGroups">Back to groups</div>

            <div class="card">
              <div class="card-header">
                <h5 class="card-title mb-0">Schemes</h5>
                <span>Schemes with this part number, please select one scheme</span>
              </div>
              <div class="col-md-12" v-if="loadingProcess">
                <div class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="table-responsive mb-0" v-if="!loadingProcess">
                <table role="table" aria-busy="false" aria-colcount="4"
                       class="table b-table table-de table-striped table-hover" id="__BVID__497"><!----><!---->
                  <thead role="rowgroup" class=""><!---->
                  <tr role="row" class="">
                    <th role="columnheader" scope="col">
                      <div>Image</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>Scheme</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>Description</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>From</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>To</div>
                    </th>
                    <th role="columnheader" scope="col" style="width: 100px;">
                      <div>Markets</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>Inrormation</div>
                    </th>
                  </tr>
                  </thead>
                  <tbody role="rowgroup">
                  <tr role="row" class="" style="cursor: pointer" v-for="(scheme, index) in schemes" :key="index"
                      @click.prevent="selectScheme(scheme)">
                    <td><img :src="scheme.img_small" alt="" style="width: 150px;"></td>
                    <td>{{ scheme.id }}</td>
                    <td>{{ scheme.description }}</td>
                    <td>{{ scheme.from }}</td>
                    <td>{{ scheme.to }}</td>
                    <td style="width: 200px;word-break: break-word;">{{ scheme.markets }}</td>
                    <td>{{ scheme.comment }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentStep === 'schemeDetail'">
          <div class="col-md-12">
            <div class="btn btn-info mb-3" @click="backToSchemes">Back to schemes</div>

            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header">
                    <h5>Scheme</h5>
                  </div>
                  <div class="card-body">
                    <img :src="selectedScheme.img_big" alt="" class="img-thumbnail">
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title mb-0">Diagram parts list</h5>
                    <span>All parts in this diagram, found part is highlighted in color</span>
                  </div>
                  <div class="table-responsive mb-0">
                    <table role="table" aria-busy="false" aria-colcount="4"
                           class="table b-table table-striped table-hover" id="__BVID__497"><!----><!---->
                      <thead role="rowgroup" class=""><!---->
                      <tr role="row" class="">
                        <th>Position</th>
                        <th>Part Number</th>
                        <th style="min-width:25%">Description</th>
                        <th>Supplement</th>
                        <th>Quantity</th>
                        <th>Effective-in date</th>
                        <th>Expiration date</th>
                        <th>Steering</th>
                        <th title="A - Replacement / E - Cancellation code" class="title_ico">A/E</th>
                        <th>Returnable</th>
                      </tr>
                      </thead>
                      <tbody role="rowgroup">
                      <tr role="row" class="" v-for="(partInScheme, index) in selectedScheme.compatibility"
                          :key="index">
                        <td>{{ partInScheme.position }}</td>
                        <td>{{ partInScheme.part_number }}</td>
                        <td>{{ partInScheme.description }}</td>
                        <td>{{ partInScheme.supplement }}</td>
                        <td>{{ partInScheme.quantity }}</td>
                        <td>{{ partInScheme.effective }}</td>
                        <td>{{ partInScheme.expiration }}</td>
                        <td>{{ partInScheme.steering }}</td>
                        <td>{{ partInScheme.replacement }}</td>
                        <td>{{ partInScheme.returnable }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import {vehicleLookUpService} from '../../_services';

export default {
  data: function () {
    return {
      loadingProcess: false,
      loaded: false,
      vin: null,
      cars: {},
      selectedCar: {},
      selectedMainGroup: {},
      selectedScheme: {},
      selectedFunctionalGroup: {},
      mainGroups: {},
      functionalGroups: {},
      schemes: {},
      currentStep: 'selectCar',
      carProperties: {},
      selectedProperty: null,
      selectedYear: null,
      selectedEngine: null,
      selectedModel: {},
      years: {},
      engines: {}
    };
  },
  created() {
    if (this.$route.query.vin) {
      this.vin = this.$route.query.vin;
      this.searchCars(this.vin);
    }

    this.getCarProperties();
  },
  methods: {
    backToCars() {
      this.currentStep = 'selectCar';
      this.selectedCar = {};
    },
    backToGroups() {
      this.currentStep = 'selectMainGroup';
    },
    backToSchemes() {
      this.currentStep = 'selectScheme';
    },
    selectCar(car) {
      this.selectedCar = car;
      this.currentStep = 'selectMainGroup';

      this.searchMainGroups(car.car_type_id);
    },
    selectScheme(scheme) {
      this.selectedScheme = scheme;
      this.currentStep = 'schemeDetail';
    },
    selectMainGroup(group) {
      this.selectedMainGroup = group;
      this.functionalGroups = group.functional_groups;
    },
    selectFunctionalGroup(group) {
      this.selectedFunctionalGroup = group;
      this.currentStep = 'selectScheme';

      this.searchSchemes(
          group.hg,
          group.fg,
          this.selectedCar.car_type_id
      );
    },
    prepareSearchCars() {
      this.$router.push({
        path: '/catalog/vehicle-lookup', query: {
          vin: this.vin
        }
      });

      this.currentStep = 'selectCar';
      this.selectedCar = {};

      this.searchCars(this.vin);
    },
    searchCars(vin) {
      this.loadingProcess = true;

      vehicleLookUpService.searchCars(vin)
          .then(
              async response => {
                this.cars = response.data.cars;
                this.loaded = true;
                this.loadingProcess = false;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    getCarProperties() {
      vehicleLookUpService.carProperties()
          .then(
              async response => {
                this.carProperties = response.data.car_properties;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    selectModel() {
      this.selectedModel = this.selectedProperty.model;
      this.years = this.selectedProperty.years;
      this.selectedYear = null;
      this.selectedEngine = null;
    },
    selectYear() {
      this.engines = this.selectedYear.engines;
      this.selectedEngine = null;
    },
    selectEngine() {
      if (
          !this.selectedProperty.car_type_id
          && !this.selectedModel
          && !this.selectedYear.year
          && !this.selectedEngine
      ) {
        return;
      }

      if (this.selectedEngine === 'null') {
        return;
      }

      this.loadingProcess = true;

      vehicleLookUpService.searchCars(
          null,
          this.selectedProperty.car_type_id,
          this.selectedModel,
          this.selectedYear.year,
          this.selectedEngine,
      )
          .then(
              async response => {
                this.cars = response.data.cars;
                this.loaded = true;
                this.loadingProcess = false;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    searchMainGroups(carTypeId) {
      this.loadingProcess = true;

      vehicleLookUpService.searchMainGroups(carTypeId)
          .then(
              async response => {
                this.mainGroups = response.data.groups;
                this.loaded = true;
                this.loadingProcess = false;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    searchSchemes(
        mainGroupId,
        functionalGroupId,
        carTypeId
    ) {
      this.loadingProcess = true;

      vehicleLookUpService.searchSchemes(
          mainGroupId,
          functionalGroupId,
          carTypeId
      )
          .then(
              async response => {
                this.schemes = response.data.schemes;
                this.loaded = true;
                this.loadingProcess = false;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
  },
}
</script>
